export enum AreaForms {
  AddArea = 'AddArea',
  EditArea = 'EditArea',
  RemoveArea = 'RemoveArea',
}
